import { createClient } from '@supabase/supabase-js';

export interface SupabaseConfig {
    url: string;
    anonKey: string;
}

export function createSupabase(config: SupabaseConfig) {
    return createClient(config.url, config.anonKey, {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
        },
        db: {
            schema: 'la_tempesta_silenziosa',
        },
    });
}
